module.exports = __webpack_public_path__ + "img/BlendBuff-Sleep.7ca1c4e4.png";